import * as React from 'react';
import HeaderView from './HeaderView';

export interface ProfileProps {
  name: string,
  image: any
}

export interface HeaderProps {
  logoClick?: any,
  profileClick?: any,
  profile?: ProfileProps,
  help?: boolean,
  helpClick?: any,
  backNav?: boolean,
  progressValue?:number,
  showPhone?:boolean
}

const Header: React.FC<HeaderProps> = (props: any) => {
  return <HeaderView {...props} />;
}

export default Header;